import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import DashboardLayout from '../views/DashboardLayout.vue'
import DashboardHome from '../views/DashboardHome.vue'
import Rooms from '../views/Rooms.vue'
import RoomDetails from '../views/RoomDetails.vue'
import Settings from '../views/Settings.vue'
import Notifications from '../views/Notifications.vue'
import Messages from '../views/Messages.vue'
import Help from '../views/Help.vue'
import RoomPublic from '../views/RoomPublic.vue'
import Paint from '../views/Paint.vue'
import Puzzle from '../views/Puzzle.vue'
import Shapes from '../views/Shapes.vue'
import Adventure from '../views/Adventure.vue'
import Letters from '../views/Letters.vue'
import MusicGame from '../views/MusicGame.vue'
import ConnectionGame from '../views/ConnectionGame.vue'
import { getApolloClient } from '../api/apollo'
import { USER_INFO_QUERY } from '../api/queries'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: Login },
  { path: '/register', name: 'Register', component: Register },
  { path: '/room/:slug', name: 'RoomPublic', component: RoomPublic },
  { path: '/room/:slug/paint', name: 'Paint', component: Paint },
  { path: '/room/:slug/puzzle', name: 'Puzzle', component: Puzzle },
  { path: '/room/:slug/shapes', name: 'Shapes', component: Shapes },
  { path: '/room/:slug/letters', name: 'Letters', component: Letters },
  { path: '/room/:slug/story', name: 'Story', component: Adventure },
  { path: '/room/:slug/connection', name: 'ConnectionGame', component: ConnectionGame },
  { path: '/room/:slug/music', name: 'MusicGame', component: MusicGame },
  {
    path: '/dashboard',
    component: DashboardLayout,
    meta: { requiresAuth: true },
    children: [
      { path: '', name: 'Dashboard', component: DashboardHome },
      { path: 'rooms', name: 'Rooms', component: Rooms },
      { path: 'rooms/:slug', name: 'RoomDetails', component: RoomDetails },
      { path: 'settings', name: 'Settings', component: Settings },
      { path: 'notifications', name: 'Notifications', component: Notifications },
      { path: 'messages', name: 'Messages', component: Messages },
      { path: 'help', name: 'Help', component: Help }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  if (to.name === 'Login' || to.name === 'Register') {
    try {
      const client = getApolloClient()
      const { data } = await client.query({ query: USER_INFO_QUERY, fetchPolicy: 'network-only' })
      const info = data?.userInfo
      if (info?.accessToken) {
        localStorage.setItem('auth_token', info.accessToken)
        localStorage.setItem('token_type', 'bearer')
      }
      if (info?.user) return { path: '/dashboard' }
    } catch {
      /* no-op */
    }
  }
  if (to.meta?.requiresAuth) {
    try {
      const client = getApolloClient()
      const { data } = await client.query({ query: USER_INFO_QUERY, fetchPolicy: 'network-only' })
      const info = data?.userInfo
      if (info?.accessToken) {
        localStorage.setItem('auth_token', info.accessToken)
        localStorage.setItem('token_type', 'bearer')
      }
      if (!info?.user) return { path: '/login' }
    } catch {
      return { path: '/login' }
    }
  }
})

export default router
